module.exports = __webpack_public_path__ + "img/date1-icon.adbff5ad.png";